export default "__VITE_ASSET__3ujrDrCk__"